import React from 'react';

const PageLoading = (props: any) => {
  const { loadingText, fullScreen } = props;
  return (
    <div className={`ar-page-load ${fullScreen ? 'full-screen' : ''}`}>
      <span className="ar-page-load__text">{loadingText}</span>
      <div className="loading-indicator" />
    </div>
  );
};

export default PageLoading;
